import React from 'react';
import Confirm from 'components/Confirm';
import Message from 'components/Message';
import LoadingDots from 'components/LoadingDots';
import { alternativeTimeLoadingModalMessages as messages } from '../../Appointments.messages';

const AlternativeTimeLoadingModal = () => (
  <Confirm title={<Message message={messages.title} />} size="medium" isOpen>
    <LoadingDots />
    <Message as="p" className="mt+" message={messages.body} />
  </Confirm>
);

export default AlternativeTimeLoadingModal;
